import { useCartStore } from '~~/stores/cart'

export const useLocationQuery = (): object => {
  const cartStore = useCartStore()

  const getLoactionQuery = () => {
    return cartStore.isHomeService
      ? { city_uuid: cartStore?.selectedCity?.uuid }
      : { facility_id: cartStore?.selectedFacility?.id }
  }

  return { getLoactionQuery }
}
